import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00:05</span> Introduction of the guest</li>
                            <li><span>01:53</span> Leo’s Background and Experiences</li>
                            <li><span>02:36</span> Starting the Entrepreneurial Journey in Food Tech</li>
                            <li><span>04:30</span> Being A Serial Entrepreneur</li>
                            <li><span>06:30</span> Launching Yalla!Market</li>
                            <li><span>04:30</span>Being A Serial Entrepreneur</li>
                            <li><span>06:30</span> Launching Yalla!Market</li>
                            <li><span>07:50</span> Coming Out of Your Comfort Zone</li>
                            <li><span>09:00</span> Inspiration Behind Yalla!Market</li>
                            <li><span>10:20</span> Focusing On Your Purpose</li>
                            <li><span>11:25</span> Working on Saturdays and Financial Freedom</li>
                            <li><span>12:20</span> Competition Management and Power of USP</li>
                            <li><span>16:30</span> Following Your Passion</li>
                            <li><span>17:22</span> Identifying Business Partnerships</li>
                            <li><span>18:40</span> Future of Food and Beverage Industry in Dubai</li>
                            <li><span>20:10</span> Long Terms Plans and Scaling Business</li>
                            <li><span>20:40</span> Corporate Social Responsibility and Conserving Environment</li>
                            <li><span>24:45</span> Advice for Aspiring Entrepreneurs</li>

                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;